import * as Sentry from '@sentry/react';
import api from 'api';
import store from 'store';

import IAsync from 'types/IAsync';
import IEnvironment from 'types/IEnvironment';

function setEnvironmentsAsync(environmentsAsync: IAsync<IEnvironment[]>) {
  store.setState({ environmentsAsync });
}

export default function fetchEnvironments(force = false) {
  const async = store.getState().environmentsAsync;

  switch (async.status) {
    case 'PENDING':
    case 'REFRESH':
      // Already fetching
      return;
    case 'INIT':
    case 'ERROR':
      setEnvironmentsAsync({ status: 'PENDING' });
      break;
    case 'SUCCESS':
      // Refetch on demand (e.g. dialog open) so freshly published
      // environments show up without a page reload.
      if (!force) return;
      setEnvironmentsAsync({ status: 'REFRESH', data: async.data });
      break;
  }

  api
    .get('environments')
    .json()
    .then(
      (data) => {
        setEnvironmentsAsync({ status: 'SUCCESS', data: data as IEnvironment[] });
      },
      (error) => {
        Sentry.captureException(error);
        setEnvironmentsAsync({ status: 'ERROR' });
      },
    );
}
